import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kill-process-dialog',
  templateUrl: './kill-process-dialog.component.html',
  styleUrls: ['./kill-process-dialog.component.scss']
})
export class KillProcessDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
